import { useEffect } from 'react';

// Counted so a popup opened on top of another (detail → edit) doesn't unlock the page early
let activeLocks = 0;

/** Stop the page behind a popup from scrolling while the popup is open */
export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    if (activeLocks++ === 0) document.body.style.overflow = 'hidden';
    return () => {
      if (--activeLocks === 0) document.body.style.overflow = '';
    };
  }, [active]);
}
